import { createSlice } from "@reduxjs/toolkit";

export const interviewConfigSlice = createSlice({
  name: "interviewconfig",
  initialState: {
    openModal: false,
    categoryOption: [],
    interviewType: "",
    interviewTypeOption: [],
    categoryId: "",
    industryOption: [],
    interviewRoleOption: [],
    interviewName: "",
    categoryName: "",
    difficulty: "beginner",
    industryType: "",
    organizationType: "",
    businessType: "",
    duration: 15,
    interviewRole: "",
    interviewTone: "",
    isQuestionGeneratedUsingAI: false,
    additonalData: "",
    description: "",
    jobDescription: "",
    createdInterview: {},
    interviewList: [],
    rubric_url: "",
  },
  reducers: {
    setOpenModal: (state, action) => {
      state.openModal = action.payload;
    },
    updateInterviewConfigField: (state, action) => {
      const { key, value } = action.payload;
      state[key] = value;
    },
    updateInterviewConfigData: (state, action) => {
      Object.assign(state, action.payload);
    },
    resetInterviewConfigField: (state) => {
      state.interviewName = "";
      state.categoryName = "";
      state.difficulty = "beginner";
      state.industryType = "";
      state.organizationType = "";
      state.businessType = "";
      state.duration = 15;
      state.interviewRole = "";
      state.interviewTone = "";
      state.isQuestionGeneratedUsingAI = false;
      state.additonalData = "";
      state.description = "";
      state.jobDescription = "";
      state.rubric_url = "";
      state.interviewType = "";
      state.interviewTypeOption = [];
      state.categoryId = "";
    },
    setCreatedInterview: (state, action) => {
      state.createdInterview = action.payload;
    },
    setInterviewList: (state, action) => {
      state.interviewList = action.payload;
    },
  },
});

const { actions, reducer: interviewConfigReducer } = interviewConfigSlice;
export const {
  setOpenModal,
  updateInterviewConfigField,
  updateInterviewConfigData,
  resetInterviewConfigField,
  setCreatedInterview,
  setInterviewList
} = actions;
export default interviewConfigReducer;
